<template>
  <div v-if="this.showCompanies">
    <div>
      <multiselect
          :model-value="selected"
          :options="options"
          :label="field"
          class="input testing"
          :can-deselect="true"
          :value-prop='track'
          :track-by="field"
          :infinite="true"
          :hide-selected="true"
          @search-change="(query) => handleSearch(query)"
          @update:modelValue="selected = $event"
          :internal-search="false"
          :loading="isLoading"
          :limit="limit"
          :max="max"
          :placeholder="placeholder"
          :max-height="300"
          :tag-position="'bottom'"
          :searchable="true"
          :resolve-on-load="false"
          :disabled="disabled"
          @open="handleOpen"
          ref="autocomplete"
      >
        <template v-slot:singlelabel="{ value }">
          <div class="multiselect-single-label">
            {{ value.full_name }}  -  ({{ value.company.name }})
          </div>
        </template>
        <template v-slot:option="{ option }">
          <div>
            {{ option.full_name }}  - ({{ option.company.name }})
          </div>
        </template>
        <template #noresults>
          <span>No items found.</span>
        </template>
      </multiselect>

      <form-error :error="error" />

      <select v-if="selectForClassicFormName" multiple :name="selectForClassicFormName" style="display: none;">
        <option v-for="s in value" :value="s.id" :key="s.id" selected>{{ s.id }} </option>
      </select>
    </div>
  </div>
  <div v-else>
    <div>
      <multiselect
          :model-value="selected"
          :options="options"
          :label="field"
          class="input"
          :can-deselect="true"
          :value-prop='track'
          :track-by="field"
          :infinite="true"
          :hide-selected="true"
          @search-change="(query) => handleSearch(query)"
          @update:modelValue="selected = $event"
          :internal-search="false"
          :loading="isLoading"
          :limit="limit"
          :max="max"
          :placeholder="placeholder"
          :max-height="300"
          :tag-position="'bottom'"
          :searchable="true"
          :resolve-on-load="false"
          :disabled="disabled"
          @open="handleOpen"
          ref="autocomplete"
      >
        <template #noresults>
          <span>No items found.</span>
        </template>
      </multiselect>

      <form-error :error="error" />

      <select v-if="selectForClassicFormName" multiple :name="selectForClassicFormName" style="display: none;">
        <option v-for="s in value" :value="s.id" :key="s.id" selected>{{ s.id }} </option>
      </select>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Multiselect from '@vueform/multiselect'

const getAsyncItems = (field, data) => payload => new Promise((resolve, reject) => {
  let items = payload[field] ?
      _.filter(data, item => item[field].toLowerCase().includes(payload[field].toLowerCase())) :
      data
  resolve({
    data: {data: items}
  })
})

export default {
  props: {
    disabled: {type: Boolean},
    type: {type: String},
    values: {type: Array, default: () => []},
    value: {type: Object, default: () => {}},
    placeholder: {type: String},
    fieldName: {type: String, default: 'name'},
    optionsProp: {type: Array, default: () => []},
    error: {type: String},
    limit: {type: Number, default: 99},
    max: {type: Number, default: 99},
    isObject: {type: Boolean, default: false},
    // used to download the transmittal pdf (project/contacts actions)
    selectForClassicFormName: {type: String, default: ''},
    track: {
      type: String,
      default: 'id'
    },
    showCompanies:{
      type: Boolean,
      default: false
    }
  },

  components: {
    Multiselect
  },

  data() {
    return {
      isLoading: false,
      options: [],
      timer: null,
      isOpen: false,
    }
  },

  mounted() {
    if (['company_contacts', 'company', 'custom'].includes(this.type)) {
      this.options = this.optionsProp;
    }

    if(['company', 'user', 'project', 'contact'].includes(this.type) && this.value) {
      setTimeout(() => {
        this.$refs.autocomplete.iv = this.value ? this.value : this.$refs.autocomplete.$parent.value
      }, 2000)
    }


  },

  computed: {
    ...mapGetters(['users', 'services', "companies", "dictionaries", "states"]),

    computedOptions() {
      return ['company_contacts', 'company', 'custom'].includes(this.type) && this.optionsProp.length ? this.optionsProp : this.options
    },

    field() {
      switch(this.type) {
        case 'company_contacts':
        case 'project':
          return 'full_name'
        case 'company':
          return 'name'
        case 'user':
          return 'full_name'
        case 'task':
          return 'title'
        case 'contact':
          return 'full_name'
        case 'state':
          return 'name'
        case 'service':
          return 'title'
        case 'category':
          return 'name'
        case 'custom':
          return this.fieldName || 'label'
        default:
          return 'label'
      }
    },

    selected: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
  },

  watch:{
    'options'(value){
      this.$emit('open', this.options)
    },

    'value'(value){
      if(value === undefined){
        this.$refs.autocomplete.iv = []
      }
      else{
        this.$refs.autocomplete.iv = value
      }
    }
  },


  methods: {
    ...mapActions(['fetchProjects', 'fetchTasks', 'fetchContacts', 'fetchUsers', 'fetchCompanies']),

    fetchItems() {
      switch(this.type) {
        case 'project':
          return this.fetchProjects
        case 'project':
          return this.fetchTasks
        case 'company':
          // return payload => {
          //   return new Promise((resolve, reject) => {
          //     let items = payload.title ?
          //         _.filter(this.companies, item => item.name.toLowerCase().includes(payload.title.toLowerCase())) :
          //         this.companies
          //
          //     resolve({
          //       data: {data: items}
          //     })
          //   })
          // }

              return this.fetchCompanies
        case 'user':
          return payload => {
            return new Promise((resolve, reject) => {
              let items = payload.full_name ?
                  _.filter(this.users, item => item.full_name.toLowerCase().includes(payload.full_name.toLowerCase()) && !item.blocked) :
                  _.filter(this.users, item => !item.blocked)

              resolve({
                data: {data: items}
              })
            })
          }
          // return this.fetchUsers
        case 'company_contacts':
          return payload => {
            return new Promise((resolve, reject) => {
              let items = this.computedOptions.filter(fil => fil.full_name.toLowerCase().includes(payload.full_name))
              resolve(
                  {
                    data: {data: items}
                  }
              )
            })
          }
          // return getAsyncItems(this.field, this.value)
        case 'contact':
          return this.fetchContacts
        case 'service':
          return payload => {
            return new Promise((resolve, reject) => {
              let items = payload.title ?
                  _.filter(this.services, item => item.title.toLowerCase().includes(payload.title.toLowerCase())) :
                  this.services

              resolve({
                data: {data: items}
              })
            })
          }
        case 'category':
          return payload => {
            return new Promise((resolve, reject) => {
              let items = payload.name ?
                  _.filter(this.dictionaries, item => item.title.toLowerCase().includes(payload.title.toLowerCase())) :
                  this.dictionaries

              resolve({
                data: {data: items}
              })
            })
          }
        case 'state':
          return payload => {
            return new Promise((resolve, reject) => {
              let items = payload.name ?
                  _.filter(this.states, item => item.title.toLowerCase().includes(payload.title.toLowerCase())) :
                  this.states

              resolve({
                data: {data: items}
              })
            })
          }
      }
    },

    start() {  // use a one-off timer
      this.timer = setInterval(() => {
        this.options = this.computedOptions
      }, 1000);
    },

    stop() {
      clearTimeout(this.timer);
    },


    handleOpen(q) {
      if (this.type !== 'custom') {
        this.isLoading = true

        this.fetchItems()({
          paginated: true
        })
            .then(res => {
              this.options = [
                ...res.data.data
              ]
              return res
            })
            .finally(res => {
              this.isLoading = false
              return res
            })

      }
    },

    handleSearch(q = '') {
      if (this.type !== 'custom' && q != '') {

        this.isLoading = true

        this.fetchItems()({
          [this.field]: q,
          limit: this.limit,
          paginated: true
        })
            .then(res => {
              this.options = [
                ...res.data.data
              ]
              return res
            })
            .finally(res => {
              this.isLoading = false
              return res
            })
      }
      if(q == '')
      {
        this.start()
      }
      if (q !== ''){
        this.stop()
      }
      else{
        this.$emit('search-changed', q);
      }
    },
  },

  handleClear() {
    this.selected = []
  }
}
</script>
